import React from 'react';
import { __ } from '@wordpress/i18n';
import { decodeEntities } from '@wordpress/html-entities';
import Loader from './Loader';
import NoCurrency from './NoCurrency';
import MultiCurrencyUpsell from './MultiCurrencyUpsell';

const CurrencyList = ( {
	currencies,
	setCurrencies,
	modalOpen,
	setNewCurrency,
	isLoading,
	status
} ) => {
	const deleteCurrency = ( currencyCode ) => {
		if (
			confirm(
				__(
					'Are you sure to delete this currency?',
					'currency-manager-for-gravity-forms'
				)
			)
		) {
			setCurrencies( ( prevCurrencies ) =>
				prevCurrencies.filter(
					( currency ) => currency.code !== currencyCode
				)
			);
		}
	};

	const editCurrency = ( selectedCode ) => {
		modalOpen( {
			modalStatus: true,
			isUpdateModal: true,
			shouldAddDropdown: false,
		} );

		const updatedCurrency = currencies.find(
			( curr ) => curr.code === selectedCode
		);

		setNewCurrency( updatedCurrency );
	};

	return (
		<div className="cmgf-container__list-wrapper">
			{ isLoading ? (
				<Loader />
			) : (
				<table className="cmgf-table">
					<thead>
						<tr>
							<th>
								{ __(
									'Currency code',
									'currency-manager-for-gravity-forms'
								) }
							</th>
							<th>
								{ __(
									'Currency name',
									'currency-manager-for-gravity-forms'
								) }
							</th>
							<th>
								{ __( 'Symbol', 'currency-manager-for-gravity-forms' ) }
							</th>
							<th>
								{ __(
									'Thousand Separator',
									'currency-manager-for-gravity-forms'
								) }
							</th>
							<th>
								{ __(
									'Decimal Separator',
									'currency-manager-for-gravity-forms'
								) }
							</th>
							<th>
								{ __(
									'Number of Decimals',
									'currency-manager-for-gravity-forms'
								) }
							</th>
							<th>
								{ __(
									'Separator demo',
									'currency-manager-for-gravity-forms'
								) }
							</th>
							<th>
								{ __( 'Actions', 'currency-manager-for-gravity-forms' ) }
							</th>
						</tr>
					</thead>
					<tbody>
						{ currencies.map( ( currency ) => (
							<tr key={ currency.code }>
								<td>{ currency.code }</td>
								<td>{ currency.name }</td>
								<td>
									{ decodeEntities( currency.symbol_left ) ||
										decodeEntities(
											currency.symbol_right
										) }
								</td>
								<td><span className='cmgf-table__separator'>{ currency.thousand_separator }</span></td>
								<td><span className='cmgf-table__separator'>{ currency.decimal_separator }</span></td>
								<td>{ currency.decimals || 2 }</td>
								<td>1{ currency.thousand_separator }000{ currency.decimal_separator }{ '0'.repeat( currency.decimals || 2 ) }</td>
								<td>
									<button
										className="cmgf-wrapper-button"
										onClick={ () =>
											editCurrency( currency.code )
										}
										aria-label={ __(
											'Edit currency',
											'currency-manager-for-gravity-forms'
										) }
									>
										{ __(
											'Edit',
											'currency-manager-for-gravity-forms'
										) }
									</button>

									<button
										className="cmgf-wrapper-button"
										onClick={ () =>
											deleteCurrency( currency.code )
										}
										aria-label={ __(
											'Delete currency',
											'currency-manager-for-gravity-forms'
										) }
									>
										{ __(
											'Delete',
											'currency-manager-for-gravity-forms'
										) }
									</button>
								</td>
							</tr>
						) ) }
					</tbody>
				</table>
			) }

			{ !isLoading && 0 === currencies.length && (
				<NoCurrency
					modalOpen = {modalOpen}
				/>
			) }
			
			{ !isLoading && (
				<MultiCurrencyUpsell />
			) }
		</div>
	);
};

export default CurrencyList;
